// extracted by mini-css-extract-plugin
module.exports = {"Notifications":"styles_Notifications__2lzVh"};